import { render, staticRenderFns } from "./DocumentMenu.vue?vue&type=template&id=c43cc8c4&scoped=true"
import script from "./DocumentMenu.vue?vue&type=script&lang=js"
export * from "./DocumentMenu.vue?vue&type=script&lang=js"
import style0 from "./DocumentMenu.vue?vue&type=style&index=0&id=c43cc8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43cc8c4",
  null
  
)

export default component.exports